import React from "react";
import "./Vision.css";
import {
  FaTint,
  FaSolarPanel,
  FaMobileAlt,
  FaCloudSun,
  FaBell,
  FaMapMarkerAlt,
  FaFileAlt,
  FaGift,
  FaHeart,
} from "react-icons/fa";

const Vision = () => {
  return (
    <section id="vision" className="vision-section section">
      <div className="vision-header">
        <span className="vision-eyebrow">OUR VISION</span>
        <h2>Driving Towards Sustainability</h2>
        <p>
          At Luxego Autospa, we believe in a greener future. We're working
          towards waterless washing technology and solar-powered equipment to
          minimise our environmental impact.
        </p>
      </div>

      <div className="vision-cards">
        <div className="vision-card">
          <div className="vision-icon"><FaTint /></div>
          <h3>Smart Wash Transition</h3>
          <p>
            We start with a traditional wash for new customers, then transition
            members to weekly or bi-weekly waterless maintenance washes that
            deliver a premium finish while saving water.
          </p>
        </div>

        <div className="vision-card">
          <div className="vision-icon"><FaSolarPanel /></div>
          <h3>Sustainable Energy Vision</h3>
          <p>
            Our goal is to power all detailing services with renewable energy,
            reducing our environmental footprint without compromising on
            quality.
          </p>
        </div>

        <div className="vision-card vision-card-list">
          <div className="vision-icon"><FaMobileAlt /></div>
          <h3>Smart Digital Car Care</h3>

          <ul>
            <li><FaCloudSun /> Smart Weather Scheduling</li>
            <li><FaBell /> Service Reminders</li>
            <li><FaMapMarkerAlt /> Live Service Tracking</li>
            <li><FaFileAlt /> Digital Vehicle Health Reports</li>
            <li><FaGift /> Loyalty & Referrals</li>
            <li><FaHeart /> Personalised Car Care</li>
          </ul>

          <div className="vision-footer">
            Powered by data-driven insights to deliver a smarter detailing
            experience.
          </div>
        </div>
      </div>
    </section>
  );
};

export default Vision;
